module.exports = __webpack_public_path__ + "2.png?a625d3d47e7937f91229221b8230a536";